export const ENGAGEMENT_AFTER_RATING = 'engagement_after_rating';
export const IMMEDIATE_ENGAGEMENT = 'immediate_engagement';